import { selectors, actions, sagas, reducer } from './model';
import { config } from './config';

export * from './types';

export const loginModel = {
  selectors,
  actions,
  config,
  sagas,
  reducer,
};
